const LAST_SEEN_KEY = "lactium:notif:lastSeen";

export const canUseBrowserNotify = () =>
  typeof window !== "undefined" && "Notification" in window;

export const browserNotifyPermission = () => {
  if (!canUseBrowserNotify()) return "unsupported";
  return Notification.permission;
};

export const requestBrowserNotify = async () => {
  if (!canUseBrowserNotify()) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
};

export const showBrowserNotify = (title, body, { onClick } = {}) => {
  if (!canUseBrowserNotify() || Notification.permission !== "granted") return false;
  try {
    const note = new Notification(title || "Lactium", {
      body: String(body || "").replace(/\s+/g, " ").trim().slice(0, 240),
      tag: `lactium-${title || "aviso"}`,
    });
    note.onclick = () => {
      window.focus();
      onClick?.();
      note.close();
    };
    return true;
  } catch (err) {
    console.error("browser notify:", err);
    return false;
  }
};

export const getLastSeenNotificationId = () => {
  try {
    return localStorage.getItem(LAST_SEEN_KEY) || "";
  } catch {
    return "";
  }
};

export const setLastSeenNotificationId = (id) => {
  try {
    if (id) localStorage.setItem(LAST_SEEN_KEY, String(id));
  } catch {
    /* ignore */
  }
};
